import type { CancelableRequestProducer } from '../common/types'
import { ideasbankApiClient as ideasAPI } from '../index'

export interface PostLikeIdeaPayload {
  ideaId: string
}

interface LikeIdeaApiResponse {
  liked: boolean
  likesCount: number
}

export interface PostLikeIdeaResponse extends LikeIdeaApiResponse {
  ideaId: string
}

export const postLikeIdea = (payload: PostLikeIdeaPayload): CancelableRequestProducer<PostLikeIdeaResponse> => {
  const { ideaId } = payload

  const producer = ideasAPI.post<LikeIdeaApiResponse>(`/ideas/${ideaId}/like`)

  return async (signal?: AbortSignal) => {
    const activeSignal = signal ?? new AbortController().signal
    const response = await producer(activeSignal)
    return {
      ...response,
      data: {
        ...response.data,
        ideaId,
      },
    }
  }
}
